<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="unIssue" :tab="$t('tab.unIssueLoadingOrder')" style="margin-top: -14px">
        <un-issue ref="unIssue"/>
      </a-tab-pane>
      <a-tab-pane key="issued" :tab="$t('tab.issuedLoadingOrder')" forceRender style="margin-top: -14px">
        <issued ref="issued"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button type="primary" @click="refresh">{{ $t('button.refresh') }}</a-button>
        <a-button type="primary" @click="reset">{{ $t('button.reset') }}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>

<script>
import UnIssue from '@/views/delivery/delivery_issue/UnIssue.vue'
import Issued from '@/views/delivery/delivery_issue/Issued.vue'

export default {
    name: 'DeliveryArrange',
    components: {
      Issued,
      UnIssue
    },
    data() {
      return {
        activeKey: 'unIssue'
      }
    },
    methods: {
      refresh() {
        this.$refs[this.activeKey].refresh()
      },
      reset() {
        this.$refs[this.activeKey].reset()
      }
    }
  }
</script>